var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app--square"},[_c('div',{staticClass:"app--square-outer-container p-5"},[_c('div',{staticClass:"app--square-inner-container"},_vm._l((_vm.squareArr),function(row,indexRow){return _c('div',{key:indexRow,staticClass:"app--square-row"},[(indexRow === 0)?_c('div',{staticClass:"app--check-result app--check-result-firstrow"},[_c('div',{staticClass:"app--check-result-firstrow1",staticStyle:{"color":"black"},style:({
              visibility:
                (!_vm.strategy || (_vm.strategy && _vm.step == 3)) &&
                _vm.isStart &&
                _vm.isDiagnoalMagic1 === true
                  ? 'visible'
                  : 'hidden',
            })},[_c('i',{staticClass:"fas fa-asterisk"})]),_c('div',{staticClass:"app--check-result-firstrow2",staticStyle:{"color":"purple","padding-right":"5px"},style:({
              visibility:
                (!_vm.strategy ||
                  (_vm.strategy == 'rowsFirst' && _vm.step >= 1) ||
                  (_vm.strategy == 'colsFirst' && _vm.step >= 2)) &&
                _vm.isStart &&
                _vm.isRowMagic[indexRow]
                  ? 'visible'
                  : 'hidden',
            })},[_c('i',{staticClass:"fas fa-asterisk"})])]):_c('div',{staticClass:"app--check-result",staticStyle:{"color":"purple","padding-right":"5px"},style:({
            visibility:
              (!_vm.strategy ||
                (_vm.strategy == 'rowsFirst' && _vm.step >= 1) ||
                (_vm.strategy == 'colsFirst' && _vm.step >= 2)) &&
              _vm.isStart &&
              _vm.isRowMagic[indexRow]
                ? 'visible'
                : 'hidden',
          })},[_vm._m(0,true)]),_vm._l((row),function(number,indexCol){return _c('div',{key:indexCol},[(indexRow === 0)?_c('div',{staticClass:"app--check-result app--check-result-lastcol"},[_c('div',{staticClass:"app--check-result-lastcol1",staticStyle:{"color":"red","padding-bottom":"5px"},style:({
                visibility:
                  (!_vm.strategy ||
                    (_vm.strategy == 'colsFirst' && _vm.step >= 1) ||
                    (_vm.strategy == 'rowsFirst' && _vm.step >= 2)) &&
                  _vm.isStart &&
                  _vm.isColMagic[indexCol]
                    ? 'visible'
                    : 'hidden',
              })},[_c('i',{staticClass:"fas fa-asterisk"})]),(indexCol === row.length - 1)?_c('div',{staticClass:"app--check-result-lastcol2",staticStyle:{"color":"blue"},style:({
                visibility:
                  (!_vm.strategy || (_vm.strategy && _vm.step == 3)) &&
                  _vm.isStart &&
                  _vm.isDiagnoalMagic2 === true
                    ? 'visible'
                    : 'hidden',
              })},[_c('i',{staticClass:"fas fa-asterisk"})]):_vm._e()]):_vm._e(),_c('div',{staticClass:"app--square-number-container"},[_c('div',{staticClass:"app--square-number"},[_vm._v(_vm._s(number))]),_c('div',{staticClass:"app--square-number-shadow"},[_vm._v(_vm._s(number))])])])})],2)}),0)]),_c('p',{staticClass:"text-center text-success"},[_vm._v("Magic sum is "+_vm._s(_vm.magicSum))]),(_vm.isSquareMagic)?_c('h5',{staticClass:"text-center text-danger mb-3"},[_vm._v("It's a magic square!")]):_vm._e(),_c('div',{staticClass:"app--action-reset pb-3"},[_c('button',{staticClass:"btn btn-secondary",on:{"click":_vm.initSquare}},[_vm._v("Reset")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fas fa-asterisk"})])}]

export { render, staticRenderFns }